module.exports = __webpack_public_path__ + "static/pokoj-nr4-photo01-nikon-6ad1c009f8bc0f7ed1a10919b1f585cb.jpg";